import { DictionaryWaterTreatmentMethodAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionaryWaterTreatmentMethods() {
  return useAutocompleteSource<DictionaryWaterTreatmentMethodAutocomplete>({
    url: EvidenceAPI.DICTIONARY_WATER_TREATMENT_METHODS + '/autocomplete',
  });
}
